<template>
  <div class="container">
    <div class="headerTask">
      <span v-for="item in authorBtns" :key="item.id">
        <el-button size="small" v-if="item.permission=='sys:insurance:add'" @click="openAddTask">新增</el-button>
      </span>
    </div>
    <publicTable :table="tableData" @onHandlePaginationChange="handlePaginationChange">
      <template #opertationTask="{scope}">
        <span v-for="item in authorBtns" :key="item.id">
          <el-button type="text" v-if="item.permission=='sys:insurance:edit'" @click="editTask(scope.row)">编辑</el-button>
          <el-button type="text" v-if="item.permission=='sys:insurance:delete'&&!scope.row.isSystemProject" class="red" @click="deleteTask(scope.row)">删除</el-button>
        </span>
      </template>
      <template #companyPayRatio="{scope}">
        <span v-if="scope.row.companyPayRatio">{{`${scope.row.companyPayRatio}%`}}</span>
      </template>
      <template #personalPayRatio="{scope}">
        <span v-if="scope.row.personalPayRatio">{{`${scope.row.personalPayRatio}%`}}</span>
      </template>
    </publicTable>

    <!-- 编辑 新增 五险一金-->
    <UpdateWxyjVue ref='updatewxyj' @refrensh="getInsurance"/>
  </div>
</template>

<script>
import publicTable from "@/components/publicTable";
import UpdateWxyjVue from './components/UpdateWxyj.vue';
import {findInsurance,insuranceTask,delInsurance} from '@/api/index'
export default {
  components: {
    publicTable,
    UpdateWxyjVue
  },
  data() {
    return {
      pages:{
        pageNo:1,
        pageSize:10,
      },
      authorBtns:[],
      tableData: {
        border: true, // 是否带有纵向边框
        stripe: true, // 是否带有斑马纹
        loading: false, // 是否显示加载动画
        hasSelect: false, // 是否显示多选
        hasOperation: false, // 是否有操作功能
        hasContextmenu: false, // 是否有右键功能
        hasShowSummary: false, // 是否显示合计行
        hasShowPagination: false, // 是否显示分页
        center: {
          textAlign: "center",
          padding: "6px 0",
        },
        page: {
          count: 10,
          pageNo: 1,
          pageSize: 1,
        },
        data: [],
        config: [
          {
            label: "缴纳项目",
            value: "name",
            show: "normal",
          },
          {
            label: "缴纳基数",
            value: "baseMoney",
            show: "normal",
          },
          {
            label: "公司缴纳比例",
            value: "companyPayRatio",
            show: "template",
          },
          {
            label: "公司缴纳金额",
            value: "companyPayMoney",
            show: "normal",
          },
          {
            label: "个人缴纳比例",
            value: "personalPayRatio",
            show: "template",
          },
          {
            label: "个人缴纳金额",
            value: "personalPayMoney",
            show: "normal",
          },
          {
            label: "操作",
            value: "opertationTask",
            show: "template",
          },
        ],
      },
    };
  },
  mounted(){
     this.getInsurance()
     this.getAuthor()
  },
  methods: {
   /** 获取按钮权限 */
    getAuthor(){
      let params = {
        permissions:'sys:insurance:edit,sys:insurance:add,sys:insurance:delete'
      }
       this.$http.post("sys/menu/findPermissionMenu", params).then((res) => {
          if (res && res.data.code == 1) {
            if (res.data.data.length) {
              this.authorBtns = res.data.data
                console.log(res.data.data)
            }
        }
      })
    },
    handlePaginationChange(data){
      const { pageNo, pageSize } = data;

			if (pageNo) {
			}

			if (pageSize) {
			}
      console.log(data)
    },
    //获取五险一金
    getInsurance(){
        findInsurance().then(res=>{
          if(res.data.code==1){
            this.tableData.data = res.data.data
            console.log(res.data)
          }
        })
    },
    editTask(row){
        console.log(row)
        this.$refs.updatewxyj.openTask('edit',row)
    },
    deleteTask(row){
         this.$confirm(`是否删除${row.name}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = {
            id:row.id
          }
          delInsurance(params).then(res=>{
            if(res.data.code==1){
              this.$message.success(res.data.msg)
              this.getInsurance()
            }
          })
        })
    },
    openAddTask() {
        this.$refs.updatewxyj.openTask('add')
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  background-color: white;
  padding: 20px;
  box-sizing: border-box;
  .headerTask {
    text-align: right;
    margin-bottom: 15px;
    /deep/ .el-button {
      background: #269d7b;
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/salary/wxyj.vue